import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'opencare-crown';

import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';

import {
  Title,
  Subtitle,
  OptionBlock,
} from '../../../common/styled-components';
import { StepWrapper } from '../../styled-components';
import SingleSelect from '../../../common/components/SingleSelect/SingleSelect';
import { useFunnelStorage } from '../../storage/Storage';
import { STEP_KEY, generateStepAnalytics } from '../../utils';

const analytics = new Analytics();

const careOptions = [
  {
    id: 'Yes',
    title: 'Yes',
    description: 'I am looking for a new dentist for ongoing care',
  },
  {
    id: 'No',
    title: 'No',
    description: 'I just need a one-off appointment for a specific issue',
  },
];

const OngoingCare = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_ongoing_care',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const goToNextStep = (value, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_ongoing_care',
      name: 'wizard',
      section: 'ongoing-care',
      position: [index],
      ...generateStepAnalytics(position, storage, {
        response: value,
      }),
    });

    storage.save(STEP_KEY.ONGOING_CARE, { ongoingCare: value }, true);
    moveToNextStep();
  };

  return (
    <div data-testid="main-reason">
      <Title id="title">
        Are you looking to join a new practice for ongoing care?
      </Title>
      <Subtitle>
        This allows the practice to structure your first appointment correctly.
      </Subtitle>
      <StepWrapper>
        <Form onFinish={goToNextStep}>
          <OptionBlock row={3}>
            {careOptions.map((option, i) => (
              <SingleSelect
                key={option.id}
                name="isUrgent"
                id={option.id}
                title={option.title}
                description={option.description}
                describedBy="title"
                onChange={e => goToNextStep(e, i)}
              />
            ))}
          </OptionBlock>
        </Form>
      </StepWrapper>
    </div>
  );
};

OngoingCare.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default OngoingCare;
